import { render, staticRenderFns } from "./IndexTask.vue?vue&type=template&id=c6a60e9e&"
import script from "./IndexTask.vue?vue&type=script&lang=js&"
export * from "./IndexTask.vue?vue&type=script&lang=js&"
import style0 from "./IndexTask.vue?vue&type=style&index=0&id=c6a60e9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports